import * as api from '../utils/api'
import {
  UPDATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_SUCCESS,
} from '@store/action-list'
import { apiAction } from '@store/actions/api'

import assert from 'assert'

import createAction from '@store/actions/create-action'
import { addProducts } from '../store/actions/products'
import {
  addProductsStores,
  removeProductsStores,
  updateProductsStores,
} from '../store/actions/products-stores'

export const fetchAllProducts = () => async (dispatch) => {
  const {
    data: { products },
  } = await api.GET('/p4/products')
  return Promise.all([dispatch(addProducts(products))])
}

export const fetchProductsStoresForProductId =
  (productId) => async (dispatch) => {
    const { data: productsStores } = await api.GET(
      `/p4/products/${productId}/stores/storeProduct`,
    )
    return dispatch(updateProductsStores(productsStores, { productId }))
  }

export const createProductStore = (data) => async (dispatch) => {
  const { data: productStore } = await api.POST(
    `/p4/products/${data.product_id}/stores`,
    data,
  )
  return dispatch(addProductsStores([productStore]))
}

export const addProductToStores = (productId, storeIds) => async (dispatch) => {
  const { data: productsStores } = await api.PATCH(
    `/p4/products/${productId}/stores`,
    { store_ids: storeIds },
  )

  return dispatch(addProductsStores(productsStores))
}

export const removeProductFromStores =
  (productId, storeIds) => async (dispatch) => {
    // CALL rather than DELETE, which only sends query params
    const {
      data: { removed },
    } = await api.CALL({
      url: `/p4/products/${productId}/stores`,
      method: 'DELETE',
      data: { store_ids: storeIds },
    })

    // Drop what the server confirms it removed.
    await dispatch(
      removeProductsStores(
        removed.map((storeId) => ({
          store_id: storeId,
          product_id: productId,
        })),
      ),
    )

    return removed
  }

export const removeProductAtStore =
  (storeId, productId) => async (dispatch) => {
    const { data: productStore } = await api.DELETE(
      `/p4/stores/${storeId}/products/${productId}`,
      null,
    )

    return dispatch(removeProductsStores([productStore]))
  }

export const setPriceForVariantAtStore =
  (storeId, variantId, price) => async (dispatch) => {
    const { data: productStore } = await api.PATCH(
      `/p4/stores/${storeId}/variants/${variantId}/price`,
      { price },
    )
    return dispatch(addProductsStores([productStore]))
  }

export const setDisabledForProductAtStore =
  (storeId, productId, state) => async (dispatch) => {
    const { data: productStore } = await api.PUT(
      `/p4/stores/${storeId}/products/${productId}/disable`,
      { state },
    )
    await dispatch(addProductsStores([productStore]))
    return productStore
  }

export const setDisabledForVariantAtStore =
  (storeId, variantId, state) => async (dispatch) => {
    const { data: productStore } = await api.PUT(
      `/p4/stores/${storeId}/variants/${variantId}/disable`,
      { state },
    )
    await dispatch(addProductsStores([productStore]))
    return productStore
  }

export const fetchProductsForStore = (storeId) => async (dispatch) => {
  const { data: products } = await api.GET(`/p4/stores/${storeId}/products`)
  return Promise.all([dispatch(addProducts(products))])
}

/**
 * Fetches a single product from the server, and adds it to redux
 */
export const fetchProduct = (id) => async (dispatch) => {
  console.log(`Fetching product ${id}`)
  const { data: product } = await api.GET(`/p4/products/${id}`)
  return Promise.all([dispatch(addProducts([product]))])
}

export const createProduct = (productData) => async (dispatch) => {
  validateProductData(productData)
  const { data: fullProduct } = await api.POST('/p4/products', productData)
  await dispatch(addProducts([fullProduct]))
  return fullProduct
}

export const softUpdateProduct = (id, data) => async (dispatch) => {
  // const { data: { product } } = await api.PATCH(`/p4/products/${id}`, data)
  return dispatch(addProducts([data]))
}

const updateProductSuccess = (data, response) => (dispatch) => {
  dispatch(addProducts([data]))
  dispatch({
    type: UPDATE_PRODUCT_SUCCESS,
    payload: data,
    response,
  })
}

export const updateProduct = (id, data) =>
  apiAction({
    url: `/p4/products/${id}`,
    method: 'PATCH',
    data,
    actionCallbacks: {
      success: updateProductSuccess,
      failure: createAction(UPDATE_PRODUCT_FAILURE),
    },
  })

const validateProductData = (data) => {
  assert(!!data.product_type, 'Must select a type.')
  assert(!!data.name, 'Must provide a name.')
  assert(!!data.square_sku, 'Must provide a SKU.')
}
